module.exports = __webpack_public_path__ + "static/media/people.cf014c78.svg";